<!-- Decorative: each page announces its accounts loading with app-loading-announcer (#6305). -->
<div class="tw-flex tw-w-full tw-flex-col tw-gap-4" aria-hidden="true">
  @for (_ of placeholders; track $index) {
    <div [class]="cardClass()" data-testid="account-row-skeleton">
      <div class="tw-flex tw-w-full tw-min-w-0 tw-items-center tw-justify-between tw-gap-3">
        <!-- Icon skeleton -->
        <div
          class="tw-h-12 tw-w-12 tw-shrink-0 tw-rounded-xl tw-bg-dt-slate-8/40 tw-animate-pulse"
        ></div>
        <!-- Name skeleton -->
        <div class="tw-flex tw-min-w-0 tw-flex-1 tw-flex-col tw-gap-2">
          <div class="tw-h-4 tw-w-32 tw-rounded tw-bg-dt-slate-8/40 tw-animate-pulse"></div>
          <div class="tw-h-3 tw-w-24 tw-rounded tw-bg-dt-slate-8/40 tw-animate-pulse"></div>
        </div>
        <!-- Value skeleton -->
        @if (showChevron()) {
          <div class="tw-flex tw-shrink-0 tw-items-center tw-gap-6">
            <div class="tw-h-5 tw-w-20 tw-rounded tw-bg-dt-slate-8/40 tw-animate-pulse"></div>
            <!-- 20×20 chevron affordance, matching account-row-renderer -->
            <div class="tw-h-5 tw-w-5 tw-rounded tw-bg-dt-slate-8/40 tw-animate-pulse"></div>
          </div>
        } @else {
          <div class="tw-flex tw-shrink-0 tw-flex-col tw-items-end tw-gap-2">
            <div class="tw-h-5 tw-w-20 tw-rounded tw-bg-dt-slate-8/40 tw-animate-pulse"></div>
            <div class="tw-h-3 tw-w-16 tw-rounded tw-bg-dt-slate-8/40 tw-animate-pulse"></div>
          </div>
        }
      </div>
    </div>
  }
</div>
